// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b0d2c6b8","239":"8e125fbc","455":"690e1e77"}[chunkId] + ".chunk.js";
};